import { Link } from "react-router-dom";
import { Button } from "../components/Button";

export default function Doneaza() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-blue-50 to-amber-50 p-6 flex items-center justify-center">
            <div className="max-w-4xl w-full bg-white/80 backdrop-blur rounded-2xl shadow-xl p-8 space-y-6">
                <div className="text-center space-y-2">
                    <h1 className="text-3xl font-bold text-indigo-700">Donează pentru Fundația Socrate</h1>
                    <p className="text-gray-700 text-lg">
                        Donațiile tale contribuie direct la dezvoltarea proiectelor educaționale pentru elevi și studenți.
                    </p>
                </div>

                {/* Grid pentru primele 4 carduri */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                    {/* Sponsorizare */}
                    <div className="bg-white/70 rounded-2xl p-6 border border-indigo-100 shadow-sm hover:shadow-md transition">
                        <h2 className="text-lg font-semibold text-indigo-700">Sponsorizare prin firmă</h2>
                        <p className="text-sm text-gray-700 mt-2">
                            Dacă reprezinți o companie, poți susține proiectele noastre prin sponsorizare.
                        </p>

                        <a
                            href="/contract.pdf"
                            download
                            className="mt-4 inline-block w-full text-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:bg-blue-700 transition"
                        >
                            Descarcă contract sponsorizare
                        </a>
                    </div>

                    {/* Redirecționare impozit pe profit */}
                    <div className="bg-indigo-50 rounded-2xl p-6 border-2 border-indigo-400 shadow-md hover:shadow-lg transition relative">
                        <span className="absolute top-3 right-3 text-xs bg-indigo-600 text-white px-3 py-1 rounded-full">
                            Recomandat
                        </span>

                        <h2 className="text-lg font-bold text-indigo-800">
                            Redirecționare impozit pe profit
                        </h2>

                        <p className="text-sm text-gray-700 mt-2">
                            Dacă reprezinți o companie, poți susține proiectele noastre prin redirecționarea unei părți din impozitul pe profit deja plătit.
                        </p>

                        <a
                            href=""
                            download
                            className="mt-4 inline-block w-full text-center px-6 py-3 bg-indigo-600 text-white font-semibold rounded-xl shadow-md hover:bg-indigo-700 transition"
                        >
                            Descarcă D177
                        </a>
                    </div>

                    {/* Direcționează 3.5% */}
                    <div className="bg-white/70 rounded-2xl p-6 border border-indigo-100 shadow-sm hover:shadow-md transition">
                        <h2 className="text-lg font-semibold text-indigo-700">
                            Direcționează 3,5% din impozitul pe venit
                        </h2>

                        <p className="text-sm text-gray-700 mt-2">
                            Susține activitatea Asociației Socrate fără niciun cost pentru tine.
                        </p>

                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm text-gray-700">
                            <li>Descarcă formularul 230 precompletat</li>
                            <li>Completează datele tale personale</li>
                            <li>Semnează formularul</li>
                            <li>Depune-l online în SPV sau la ANAF</li>
                        </ul>

                        <a
                            href="/formular-230-asociatia-socrate.pdf"
                            download
                            className="mt-4 inline-block w-full text-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:bg-blue-700 transition"
                        >
                            Descarcă formular 230
                        </a>
                    </div>

                    {/* Donație unică */}
                    <div className="bg-white/70 rounded-2xl p-6 border border-indigo-100 shadow-sm hover:shadow-md transition">
                        <h2 className="text-lg font-semibold text-indigo-700">Donație unică</h2>

                        <p className="text-sm text-gray-700 mt-2">
                            O contribuție punctuală, rapidă.
                        </p>

                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm text-gray-700">
                            <li>Beneficiar: Fundația “Socrate”</li>
                            <li>Banca: CEC Bank SA - Arad</li>
                            <li>IBAN: RO23CECEAR0130RON0487941</li>
                            <li>SWIFT/BIC: CECEROBUXXX</li>
                            <li>Mențiune: Donație</li>
                        </ul>
                    </div>
                </div>

                {/* Flex pentru ultimele 2 carduri */}
                <div className="flex flex-col md:flex-row gap-4">
                    {/* Donație lunară */}
                    <div className="flex-1 bg-white/70 rounded-2xl p-6 border border-indigo-100 shadow-sm hover:shadow-md transition">
                        <h2 className="text-lg font-semibold text-indigo-700">Donație lunară</h2>

                        <p className="text-sm text-gray-700 mt-2">
                            Susținere constantă pentru proiecte pe termen lung.
                        </p>

                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm text-gray-700">
                            <li>Beneficiar: Fundația “Socrate”</li>
                            <li>Banca: CEC Bank SA - Arad</li>
                            <li>IBAN: RO23CECEAR0130RON0487941</li>
                            <li>SWIFT/BIC: CECEROBUXXX</li>
                            <li>Mențiune: Donație lunară</li>
                        </ul>
                    </div>

                    {/* Ghid */}
                    <div className="flex-1 bg-white/70 rounded-2xl p-6 border border-indigo-100 shadow-sm hover:shadow-md transition">
                        <h2 className="text-lg font-semibold text-indigo-700">
                            Ghid orientativ privind Declarațiile D177 și D230
                        </h2>

                        <p className="text-sm text-gray-700 mt-2">
                            Prezentul document explică modul de completare și depunere a declarațiilor necesare redirecționării impozitului.
                        </p>

                        <a
                            href="/ghid.pdf"
                            download
                            className="mt-4 inline-block w-full text-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:bg-blue-700 transition"
                        >
                            Descarcă ghidul
                        </a>
                    </div>
                </div>

                <Link to="/">
                    <Button variant="outline" className="w-full">
                        Înapoi la pagina principală
                    </Button>
                </Link>
            </div>
        </div>
    );
}